import { useState, useCallback } from 'react';

export const useViewedFindings = (analysisId: string) => {
  const [viewedFindings, setViewedFindings] = useState<Set<string>>(() => {
    const stored = localStorage.getItem(`viewed_findings_${analysisId}`);
    return stored ? new Set(JSON.parse(stored)) : new Set<string>();
  });

  const markAsViewed = useCallback(
    (findingId: string) => {
      setViewedFindings((prev) => {
        const updated = new Set(prev);
        updated.add(findingId);

        localStorage.setItem(
          `viewed_findings_${analysisId}`,
          JSON.stringify(Array.from(updated))
        );

        return updated;
      });
    },
    [analysisId]
  );

  const clearViewed = useCallback(() => {
    setViewedFindings(new Set<string>());
    localStorage.removeItem(`viewed_findings_${analysisId}`);
  }, [analysisId]);

  return {
    viewedFindings,
    markAsViewed,
    clearViewed
  };
};
